import React, { Component } from 'react'
import { connect } from 'react-redux'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import { injectIntl } from 'react-intl'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import {
  showFeedbackFormModal,
  saveFeedbackForm,
} from 'reducers/feedback/reducer'
import withPromise from 'helpers/withPromise'
import FeedbackInfo from './FeedbackInfo'
import FeedbackForm from './FeedbackForm'
import messages from './translate'
import 'styles/widgets/feedback.scss'

export class FeedbackModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowInfo: false,
      email: '',
    }
  }

  onClose = () => {
    this.props.showFeedbackFormModal(false)
    this.onAddMoreFbClick()
  }

  onAddMoreFbClick = () => this.setState({ isShowInfo: false, email: '' })

  onFeedbackSubmit = values => {
    const {
      intl: { formatMessage },
    } = this.props

    return withPromise(this.props.saveFeedbackForm, {
      form: values,
      successMessage: formatMessage(messages.afterSaveFeedbackMessage),
    }).then(errors => {
      if (errors) {
        return Promise.resolve(errors)
      }

      this.setState({
        isShowInfo: true,
        email: values.email,
      })
    })
  }

  render() {
    const {
      intl: { formatMessage },
      isShowFeedbackFormModal,
    } = this.props
    const { isShowInfo, email } = this.state

    return (
      <Dialog
        fullScreen={ifWindowWidthLessThan(599)}
        open={isShowFeedbackFormModal}
        onClose={this.onClose}
        className="feedback-modal">
        <AppBar position="absolute">
          <Toolbar className="event-modal-toolbar">
            <Typography variant="h6">
              {formatMessage(
                isShowInfo
                  ? messages.feedbackThanksHeader
                  : messages.leaveFeedback,
              )}
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="close"
              className="close-icon"
              onClick={this.onClose}>
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className="feedback-content">
          {Boolean(isShowInfo) && (
            <FeedbackInfo
              onAddMoreFbClick={this.onAddMoreFbClick}
              email={email}
            />
          )}
          {Boolean(!isShowInfo) && (
            <FeedbackForm onSubmit={this.onFeedbackSubmit} />
          )}
        </div>
      </Dialog>
    )
  }
}

export default connect(
  state => ({
    isShowFeedbackFormModal: state.getIn([
      'feedback',
      'isShowFeedbackFormModal',
    ]),
  }),
  {
    showFeedbackFormModal,
    saveFeedbackForm,
  },
)(injectIntl(FeedbackModal))
